import { RouteRecordRaw } from "vue-router";
import routesName from "@/utils/constants/routesName";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import { UserRoleEnum } from "@/utils/enum/UserRoleEnum";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: routesName.dashboard,
    redirect: {
      name: routesName.courses,
    },
    meta: { protected: true },
  },
  {
    path: "/login",
    name: routesName.login,
    component: () => import("@/views/LoginView.vue"),
    meta: { notAuthorized: true, layout: EmptyLayout },
  },
  {
    path: "/confirm/:token/password",
    name: routesName.confirmAccount,
    component: () => import("@/views/ConfirmAccount.vue"),
    meta: { notAuthorized: true, layout: EmptyLayout },
  },
  {
    path: "/courses",
    name: routesName.courses,
    component: () => import("@/views/CoursesView.vue"),
    meta: { protected: true, title: "Courses" },
  },
  {
    path: "/courses/create",
    name: routesName.courseCreate,
    component: () => import("@/views/CourseCreateView.vue"),
    meta: { protected: true, title: "Create course" },
  },
  {
    path: "/courses/:id/edit",
    name: routesName.courseEdit,
    component: () => import("@/views/CourseEditView.vue"),
    meta: { protected: true, title: "Edit course" },
  },
  {
    path: "/modules/create",
    name: routesName.moduleCreate,
    component: () => import("@/views/CourseCreateView.vue"),
    meta: { protected: true, title: "Create module" },
  },
  {
    path: "/modules/:id/edit",
    name: routesName.moduleEdit,
    component: () => import("@/views/CourseEditView.vue"),
    meta: { protected: true, title: "Edit module" },
  },
  {
    path: "/parts/create",
    name: routesName.partCreate,
    component: () => import("@/views/CourseCreateView.vue"),
    meta: { protected: true, title: "Create part" },
  },
  {
    path: "/parts/:id/edit",
    name: routesName.partEdit,
    component: () => import("@/views/CourseEditView.vue"),
    meta: { protected: true, title: "Edit part" },
  },
  {
    path: "/learning-centers",
    name: routesName.learningCenters,
    component: () => import("@/views/LearningCentersView.vue"),
    meta: { protected: true, title: "Learning centers" },
  },
  {
    path: "/learning-centers/create",
    name: routesName.learningCenterCreate,
    component: () => import("@/views/LearningCenterCreateView.vue"),
    meta: { protected: true, title: "Create learning center" },
  },
  {
    path: "/learning-centers/:id/edit",
    name: routesName.learningCenterEdit,
    component: () => import("@/views/LearningCenterEditView.vue"),
    meta: { protected: true, title: "Edit learning center" },
  },
  {
    path: "/users",
    name: routesName.users,
    component: () => import("@/views/UsersView.vue"),
    meta: { protected: true, title: "Users", roles: [UserRoleEnum.admin] },
  },
  {
    path: "/managers",
    name: routesName.managers,
    component: () => import("@/views/ManagersView.vue"),
    meta: {
      protected: true,
      title: "User management",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/managers/create",
    name: routesName.managerCreate,
    component: () => import("@/views/ManagersCreateView.vue"),
    meta: {
      protected: true,
      title: "Create new administrator",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/user/:id",
    name: routesName.singleUser,
    component: () => import("@/views/SingleUserView.vue"),
    meta: {
      protected: true,
      title: "User info",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/blog",
    name: routesName.blog,
    component: () => import("@/views/BlogView.vue"),
    meta: { protected: true, title: "Blog" },
  },
  {
    path: "/trending-specialties",
    name: routesName.trendingSpecialties,
    component: () => import("@/views/TrendingSpecialtiesView.vue"),
    meta: {
      protected: true,
      title: "Trending specialties",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/settings/specialties/create",
    name: routesName.specialtyCreate,
    component: () => import("@/views/SpecialtyCreateView.vue"),
    meta: {
      protected: true,
      title: "Create specialty",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/settings/specialties/:id/edit",
    name: routesName.specialtyEdit,
    component: () => import("@/views/SpecialtyEditView.vue"),
    meta: {
      protected: true,
      title: "Edit specialty",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/settings/credits/create",
    name: routesName.creditCreate,
    component: () => import("@/views/CreditCreateView.vue"),
    meta: {
      protected: true,
      title: "Create credit",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/settings/credits/:id/edit",
    name: routesName.creditEdit,
    component: () => import("@/views/CreditEditView.vue"),
    meta: {
      protected: true,
      title: "Edit credit",
      roles: [UserRoleEnum.admin],
    },
  },
  {
    path: "/settings",
    redirect: "/settings/credits",
  },
  {
    path: "/settings/:group?/:tab?",
    name: routesName.settings,
    component: () => import("@/views/SettingsView.vue"),
    meta: { protected: true, title: "Settings", roles: [UserRoleEnum.admin] },
  },
  {
    path: "/:pathMatch(.*)*",
    name: routesName.notFound,
    meta: { protected: true },
    component: () => import("@/views/NotFoundView.vue"),
  },
];

export default routes;
